import { abi } from './abi';
import { ETH_REWARDS_MANAGER_CONTRACT_ADDRESS } from './constants';
export class EthRewardsManager {
    constructor(client, { address } = {}) {
        this.getAntiAbuseOracleAddresses = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getAntiAbuseOracleAddresses'
        });
        this.client = client;
        this.address = address ?? ETH_REWARDS_MANAGER_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=ethRewardsManager.js.map